module.exports = __webpack_public_path__ + "img/left_top_3.75d8cbb.png";